import { render, staticRenderFns } from "./DiscountActions.vue?vue&type=template&id=5fa5c87a"
import script from "./DiscountActions.vue?vue&type=script&lang=js"
export * from "./DiscountActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports